import React from "react";

export default function LoadingIndicator() {
  return (
    <div className="spinner-border" style={{ borderWidth: 2 }} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
